import { NavDropdown } from "react-bootstrap";
import StyledNavDropdown from "./StyledNavDropdown";
import { useNavigate, useLocation } from "react-router-dom";
import { MapView } from "../../../../constant/VectorTileLayerType";
import { useTenantContext } from "../../../../context/Tenant/TenantContext";

const ViewLayerSelect = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { config } = useTenantContext();

  const setLayer = (layer: string) => {
    navigate(`/view/${layer}`);
  };

  const isDataCutterActive = location.pathname === "/";
  const isCensusActive = location.pathname === `/view/${MapView.GB_CENSUS}`;
  const isInrixVolumeActive =
    location.pathname === `/view/${MapView.INRIX_VOLUME}`;
  const isInrixAverageSpeedActive =
    location.pathname === `/view/${MapView.INRIX_AVERAGE_SPEED}`;

  const isInrix = config.name === "Inrix";

  return (
    <StyledNavDropdown title={<span className="mr-2 text-white">View</span>}>
      <NavDropdown.Item
        active={isDataCutterActive}
        onClick={() => navigate("/")}
      >
        DataCutter
      </NavDropdown.Item>

      {!isInrix && (
        <NavDropdown.Item
          active={isCensusActive}
          onClick={() => setLayer(MapView.GB_CENSUS)}
        >
          GB Census
        </NavDropdown.Item>
      )}

      {isInrix && (
        <NavDropdown.Item
          active={isInrixVolumeActive}
          onClick={() => setLayer(MapView.INRIX_VOLUME)}
        >
          Volume
        </NavDropdown.Item>
      )}
      {isInrix && (
        <NavDropdown.Item
          active={isInrixAverageSpeedActive}
          onClick={() => setLayer(MapView.INRIX_AVERAGE_SPEED)}
        >
          Speed Profiles
        </NavDropdown.Item>
      )}
    </StyledNavDropdown>
  );
};

export default ViewLayerSelect;
